import axiosInstance from "@/services/http/axios-instance";

export class UserApi {
  loadUserData() {
    return axiosInstance.post("/auth/me");
  }

  saveUserData(userData) {
    return axiosInstance.post("/me", {
      ...userData,
    });
  }
}
